import type { ExperimentConfig } from '../@types'

// DEV-34789 — EU pricing unification, Group 2 (currently €44 renewal → test €39 ladder).
// EU-only A/B (variant B = €39 weekly renewal ladder). EU-scoping is enforced by the ABsmartly
// audience (country ∈ EU set); every targeted funnel swaps to the €39 ladder via the shared transform.
// Debug (per funnel): /result_complete?safe&mock-data&utm_source=FB&country=DE&area=<appArea>&exp=web_eu_pricing_unification_g2~1
const paywall = {
	experiment: () =>
		import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_eu_pricing_unification_g2'),
}

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': { paywall },
		'activity-female-tai-chi-walking-pr': { paywall },
	},
]

export default config
